// Simple encryption/decryption utilities for localStorage
// Note: This is basic encryption for demonstration. In production, consider using a more robust solution.

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'default-key';

// Simple XOR encryption (for demonstration purposes)
const encrypt = (text: string): string => {
  let result = '';
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(
      text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length)
    );
  }
  return btoa(result); // Base64 encode
};

const decrypt = (encryptedText: string): string => {
  try {
    const text = atob(encryptedText); // Base64 decode
    let result = '';
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(
        text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length)
      );
    }
    return result;
  } catch (error) {
    console.error('Error decrypting data:', error);
    return '';
  }
};

export const secureStorage = {
  setItem: (key: string, value: any): void => {
    try {
      const stringValue = JSON.stringify(value);
      const encryptedValue = encrypt(stringValue);
      localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.error('Error storing encrypted data:', error);
    }
  },

  getItem: (key: string): any => {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;
      
      const decryptedValue = decrypt(encryptedValue);
      return JSON.parse(decryptedValue);
    } catch (error) {
      console.error('Error retrieving encrypted data:', error);
      return null;
    }
  },

  removeItem: (key: string): void => {
    localStorage.removeItem(key);
  },

  clear: (): void => {
    localStorage.clear();
  }
};
